var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecurlyRLogomarkPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.091 54.675L150.149 54.6771V54.675C150.09 54.675 149.084 54.675 149.091 54.675Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150 7.15256e-06C67.1573 7.15256e-06 0 67.1583 0 150C0 232.843 67.1573 300 150 300C232.844 300 300 232.843 300 150C300 67.1583 232.844 7.15256e-06 150 7.15256e-06Z",
    fill: "#6A2783"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M149.091 54.675L150.149 54.6771V54.675C150.09 54.675 149.084 54.675 149.091 54.675Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M171.323 161.382C192.976 155.901 214.377 137.773 214.377 108.207C214.377 71.975 189.526 54.6895 150.191 54.677H150.149C115.432 54.6875 95.3709 71.0687 90.6834 99.466H73.4609L107.884 128.735L144.266 99.466H124.72C124.72 99.466 124.876 79.1333 150.606 79.1333C172.565 79.1333 180.067 95.1367 180.067 108.45C180.067 127.848 169.81 142.538 145.233 142.538H90.638L90.6168 236.925H125.054V165.885H125.163C132.742 165.885 140.107 168.696 152.819 187.52L183.477 236.925H221.8L190.163 186.261C181.842 173.315 175.64 164.773 171.323 161.382Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurlyRLogomarkPurple);
export default __webpack_public_path__ + "static/media/Recurly_R_Logomark_Purple.bacd754b65b7a3e27d618cd195eaa3fc.svg";
export { ForwardRef as ReactComponent };